module.exports = __webpack_public_path__ + "img/play.f6781b0d.svg";